module.exports = __webpack_public_path__ + "static/media/mountains.e3aa0ae3.svg";